import React from "react";

const NewsEmailSuccessfully = ({ id, isNewsEmailSuccessfullyOpen }) => {
  return (
    <>
      <div
        id={id}
        className={`${
          isNewsEmailSuccessfullyOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[32%] mx-auto">
            <div className="mb-5 mx-auto items-center justify-center">
              <div className="w-full flex flex-col items-center">
                <p className="items-center text-center font-[600] text-[16px] mt-5 mb-8">
                  Success
                </p>
                <svg
                  width="83"
                  height="83"
                  viewBox="0 0 83 83"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="41.5" cy="41.5" r="41.5" fill="#17C6C6" />
                  <path
                    d="M19.5 41.5L31.5 50.8L63.4998 23.8"
                    stroke="white"
                    stroke-width="3"
                  />
                </svg>
                <p className="items-center text-center font-[400] text-[14px] text-[#4A4747] mt-8 mb-2">
                  Email changed successfully
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsEmailSuccessfully;
